import React from 'react';
import PropTypes from 'prop-types';
import { H6, NoTranslate } from '@contently/toolkit';

const AnswerDisplay = ({ question }) => (
  <div className="row">
    <H6 className="as-label">{question.label}</H6>
    <NoTranslate text={question.value || 'No answer provided'} />
  </div>
);

AnswerDisplay.propTypes = {
  question: PropTypes.shape({
    label: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired
  }).isRequired
};

export default AnswerDisplay;



// WEBPACK FOOTER //
// ./app/javascript/app/components/questions/AnswerDisplay.jsx